export default {
  title: 'Apăsați sau trageți fișierul în această zonă pentru a-l încărca',
  description: 'Formate acceptate: .csv, .xls, .xlsx',
  buttons: {
    download_template: 'Descarcă șablonul de import',
  },
  toasts: {
    error: 'Eroare la încărcarea fișierului',
  },
};
